import { useEffect, useRef, useState } from "react";

export function AnimatedNumber({ value = 0, duration = 1000, suffix = "", className }) {
  const [display, setDisplay] = useState(0);
  const ref = useRef();
  useEffect(() => {
    let start;
    const from = 0;
    const to = Number(value) || 0;
    const step = (ts) => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(from + (to - from) * eased));
      if (p < 1) ref.current = requestAnimationFrame(step);
    };
    ref.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(ref.current);
  }, [value, duration]);
  return (
    <span className={className}>
      {display}
      {suffix}
    </span>
  );
}
